export const TYPE_LABELS = {
  WKI: 'Weekly Invoice',
  WIR: 'Weekly Invoice Rev',
  WRR: 'Rev Weekly Remittance',
  INC: 'Income',
  GLS: 'Garage Loss',
  RLS: 'Reallocation Loss',
  MLS: 'Impact Loss',
  DLS: 'Off Day',
  DSO: 'Sick Off',
  DRL: 'Recollection Loss',
  GLR: 'Garage Loss Rev',
  RLR: 'Reallocation Loss Rev',
  MLR: 'Impact Loss Rev',
  DLR: 'Off Day Rev',
  DSR: 'Sick Off Rev',
  OFP: 'Office Payment',
  OFR: 'Office Payment Rev',
  DRP: 'Debt Recovery',
  DRR: 'Debt Recovery Rev',
  FNP: 'Fine & Penalty',
  FNR: 'Fine & Penalty Rev',
  OTP: 'Other Payment',
  OTR: 'Other Payment Rev',
  OCH: 'Other Charge',
  OCR: 'Other Charge Rev',
  DEP: 'Deposit',
  FUL: 'Fuel',
  REG: 'Registration Fee',
  RDP: 'Deposit Rev',
  RFL: 'Fuel Rev',
  RRG: 'Registration Fee Rev',
  PAY: 'Payment',
  CHG: 'Charge',
  ADJ: 'Adjustment',
  REV: 'Reversal',
  FIN: 'Fine',
};
